export default __webpack_public_path__ + "static/image2-a6239bfbbb6a3e41c7d60db5cc985084.jpg";